import React, { useEffect, useState } from "react"
import CustomInput from "../../SharedComponents/CustomInput/CustomInput"
import { initialCreatePayrollFormValues, PAY_PERIOD } from "../../Models/AddPayroll"
import { PAYROLL_FIELD_KEY_NAMES } from "../../constants/Enums";
import InputLabel from "../../SharedComponents/InputLabel/InputLabel";
import Select from 'react-select';

export interface NewContactProps {
    draftData?: any;
    formData?: any;
    populateFormData?: any;
    // passingInteraction?: (callback: CallBackPayloadType) => void;
}
export interface ReactSelectOptionsType {
    value: string | number;
    label: string;
}

function AddPayroll(props: NewContactProps) {

    const [formState, setFormState] = useState(initialCreatePayrollFormValues);

    useEffect(() => {
        let payScheduleOptions: ReactSelectOptionsType[] = [];
        let payPeriodOptions: ReactSelectOptionsType[] = [];
        let payDayOptions: ReactSelectOptionsType[] = [];

        payScheduleOptions = [
            {
                value: "123455",
                label: "Monthly",
            }
        ];

        PAY_PERIOD.forEach((element: any) => {
            let option: ReactSelectOptionsType = {
                label: element.name,
                value: element.id
            };
            payPeriodOptions.push(option);
        });

        payDayOptions = [
            {
                label: "Monthly",
                value: "12342223"
            }
        ];

        const updatedState = formState;

        if(updatedState.payschedule) {
            let selectedOption: ReactSelectOptionsType | undefined;
            if (props.populateFormData && props.populateFormData.payableAccountCode) {
                const accountCode: string = props.populateFormData.payableAccountCode;
                selectedOption = payScheduleOptions.filter(
                    (option) => option.value === accountCode
                )[0];
            }
            updatedState.payschedule = {
                ...updatedState.payschedule,
                options: [...payScheduleOptions],
                defaultValue: selectedOption
                    ? selectedOption
                    : payScheduleOptions[0],
                value: selectedOption ? selectedOption : payScheduleOptions[0]
            };
        }
        setFormState({ ...updatedState });
        return () => {
            // null
        };
    }, [props])

    // const formFieldChanged = (
    //     newValue: ReactSelectOptionsType | string | null,
    //     sectionName: CONTACT_FIELD_SECTION_NAMES,
    //     fieldName: CONTACT_FIELD_KEY_NAMES
    // ) => {
    //     const updatedState = formState;
    //     const sectionValue: Accounting | GeneralInfo | AddressInfo =
    //         updatedState[sectionName];
    //     for (const [key, objValue] of Object.entries(sectionValue)) {
    //         const objKey = objValue.key;
    //         let resultFound: boolean = false;
    //         if (!resultFound && objKey === fieldName) {
    //             if (objValue.isMandatory) {
    //                 switch (objValue.key) {
    //                     case CONTACT_FIELD_KEY_NAMES.NAME:
    //                         objValue.hasError = Utility.nonZeroLength(newValue as string)
    //                             ? false
    //                             : true;
    //                         break;
    //                     case CONTACT_FIELD_KEY_NAMES.PAN_NUMBER:
    //                         const panNumber = newValue as string;
    //                         const regex = new RegExp(PAN_REGEX_PATTERN);
    //                         objValue.hasError = !regex.test(panNumber);
    //                         break;
    //                     case CONTACT_FIELD_KEY_NAMES.GST_IN:
    //                         const gstIn = newValue as string;
    //                         const gstRegex = new RegExp(GSTIN_REGEX_PATTERN);
    //                         objValue.hasError = !gstRegex.test(gstIn);
    //                         break;
    //                     default:
    //                     // null
    //                 }
    //             }
    //             objValue.value = newValue;
    //             resultFound = true;
    //         }
    //     }
        // setFormState({ ...updatedState });
    // }

    const formFieldChanged = (
        newValue: ReactSelectOptionsType | string | null,
        fieldName: PAYROLL_FIELD_KEY_NAMES
    ) => {
        const updatedState = formState;
        const fieldValue = updatedState[fieldName];
        const objKey = fieldValue.key;
        let resultFound: boolean = false;
        if (!resultFound && objKey === fieldName) {
            fieldValue.value = newValue
        }
    }

    return (
        <div className="px-2">
            <div className="parent-width row flex-wrap">
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    {formState.payschedule.options && (
                        <>
                            <InputLabel text={'Pay Schedule'} />
                            <Select
                                options={formState.payschedule.options}
                                placeholder="Select a pay "
                                isSearchable={false}
                                defaultValue={formState.payschedule.defaultValue}
                                onChange={(value) =>
                                    formFieldChanged(
                                        value,
                                        // CONTACT_FIELD_SECTION_NAMES.ACCOUNTING_INFO,
                                        PAYROLL_FIELD_KEY_NAMES.PAY_SCHEDULE
                                    )
                                }
                            />
                            <div className="mt-5"></div>
                        </>
                    )}
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
                <div
                    className={'flex-1 ' + (true ? 'p-3' : 'px-3')}
                    style={{ minWidth: '250px', maxWidth: '400px' }}
                >
                    <CustomInput
                        hasError={false}
                        defaultValue={"Hello"}
                        placeholder={'Auto-Numbering-Format'}
                        labelName="Auto-Numbering-Format"
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddPayroll